// extracted by mini-css-extract-plugin
export default {"title":"_2XIwL___Header-module__title"};